module.exports = __webpack_public_path__ + "static/yellow-logo-cbb0bd9a71661fe4bc6748a661d0e53a.png";